/**
 * Exporta a XLSX el Reporte de Estimación de Alumnado.
 *
 * @param {Object} params
 * @param {Array}  params.programas - Grupos de programa con filas y total_programa
 * @param {Object} params.contexto  - { ciclo, campus, seccion, programa, institucion }
 */
import * as XLSX from 'xlsx';

const COLUMNAS = [
  'Programa',
  'Tetramestre',
  'Nuevo Ingreso',
  'Reingresos',
  'Reinscripción',
  'Total Estimación',
];

function fechaArchivo() {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}_${pad(d.getHours())}${pad(d.getMinutes())}`;
}

export function exportReporteEstimacionAlumnadoXLS({ programas = [], contexto = {}, estadisticas = null } = {}) {
  const {
    ciclo = '—',
    campus = 'Todos',
    seccion = 'Todas',
    programa = 'Todos',
    institucion = '—',
  } = contexto;

  const aoa = [
    ['ESTIMACIÓN DE ALUMNADO'],
    [`Institución: ${institucion}`],
    [`Ciclo Escolar: ${ciclo}`],
    [`Programa: ${programa}`],
    [`Campus: ${campus}`],
    [`Sección: ${seccion}`],
    [`Generado: ${new Date().toLocaleString('es-MX')}`],
  ];

  // Estadísticas informativas
  if (estadisticas) {
    aoa.push([]);
    aoa.push(['INDICADORES DEL CICLO']);
    aoa.push([`Total Alumnado Activo: ${estadisticas.total_actual ?? 0}`]);
    aoa.push([`Nuevo Ingreso: ${estadisticas.total_nuevo_ingreso ?? 0}`]);
    aoa.push([`Reinscripción: ${estadisticas.total_reinscripcion ?? 0}`]);
    aoa.push([`Reingreso: ${estadisticas.total_reingreso ?? 0}`]);
    aoa.push([`Bajas: ${estadisticas.total_bajas ?? 0}`]);
    aoa.push([`% Reinscripción: ${estadisticas.pct_reinscripcion ?? 0}%`]);
    aoa.push([`% Deserción: ${estadisticas.pct_desercion ?? 0}%`]);
    aoa.push([`% Total Activos: ${estadisticas.pct_total ?? 0}%`]);
  }

  aoa.push([]);
  aoa.push(COLUMNAS);

  programas.forEach((prog) => {
    (prog.filas || []).forEach((fila) => {
      aoa.push([
        prog.nombre_programa || '',
        fila.tetramestre ?? '',
        fila.nuevo_ingreso ?? 0,
        fila.reingresos ?? 0,
        fila.reinscripcion ?? 0,
        fila.total_estimacion ?? 0,
      ]);
    });

    // Fila TOTAL PROGRAMA
    const t = prog.total_programa || {};
    aoa.push([
      `TOTAL PROGRAMA — ${prog.nombre_programa || ''}`,
      '',
      t.nuevo_ingreso ?? 0,
      t.reingresos ?? 0,
      t.reinscripcion ?? 0,
      t.total_estimacion ?? 0,
    ]);

    // Separador entre programas
    aoa.push([]);
  });

  const ws = XLSX.utils.aoa_to_sheet(aoa);

  ws['!cols'] = [
    { wch: 45 },
    { wch: 14 },
    { wch: 16 },
    { wch: 14 },
    { wch: 16 },
    { wch: 18 },
  ];

  ws['!merges'] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: 5 } },
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Estimación Alumnado');

  const fileName = `reporte_estimacion_alumnado_${fechaArchivo()}.xlsx`;
  XLSX.writeFile(wb, fileName);
}

export default exportReporteEstimacionAlumnadoXLS;
